<template>
  <div class="flex items-center gap-1 transition duration-150" :class="colorClass">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      :class="size ?? 'w-6 h-6'"
    >
      <!-- Icon from Lucide by Lucide Contributors - https://github.com/lucide-icons/lucide/blob/main/LICENSE -->
      <path
        :fill="liked ? 'currentColor' : 'none'"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2c-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"
      />
    </svg>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  liked?: boolean
  size?: string
  color?: string
}>()

const colorClass = computed(() => {
  if (props.color) {
    return props.color
  } else if (props.liked) {
    return 'text-red-500'
  } else {
    return 'text-stone-400'
  }
})
</script>
